'use strict';

import { view } from '@/functions';

const prefix = '/tap-to-phone-devices';

export default [
    {
        path: prefix,
        name: 'tap-to-phone-devices',
        meta: {
            title: 'Tap to phone devices',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('tap-to-phone-devices/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'tap-to-phone-devices-info',
        meta: {
            title: 'Tap to phone devices',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('tap-to-phone-devices/info'),
    },
];
